/*
 * @Descripttion:
 * @Author: huxianglong
 * @Date: 2023-07-03 10:59:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-02-04 10:27:50
 */
// 处理请求路径和图片地址
const urlArr = [
  {
    hostName: "wuwai.com",
    postUrl: "https://mapi.wuwai.com",
    index: 1,
    ico: "yqk.ico",
    title: "翼启考",
    imgBg: new URL(`@/assets/img/yqk/img_bg@2x.png`, import.meta.url).href,
    imgLogo: new URL(`@/assets/img/yqk/logo@2x.png`, import.meta.url).href,
  },
  {
    hostName: "huixuebang.com",
    postUrl: "https://api.huixuebang.com",
    index: 2,
    ico: "hxb.ico",
    title: "汇学邦",
    imgBg: new URL(`@/assets/img/hxb/img_bg@2x.png`, import.meta.url).href,
    imgLogo: new URL(`@/assets/img/hxb/logo@2x.png`, import.meta.url).href,
  },
  {
    hostName: "192.168.0.159", //192.168.0.159
    postUrl: "http://192.168.0.12:9130", //"http://192.168.0.12:9130", //"https://mapi.wuwai.com",
    index: 1,
    title: "翼启考",
    ico: "yqk.ico",
    imgBg: new URL(`@/assets/img/yqk/img_bg@2x.png`, import.meta.url).href,
    imgLogo: new URL(`@/assets/img/yqk/logo@2x.png`, import.meta.url).href,
  },
];
const currentHostName = window.location.hostname;
const postData = urlArr.find((ele) => currentHostName.includes(ele.hostName));

const changeFavicon = (link: any, title: any) => {
  let favicon = document.querySelector('link[rel="icon"]');
  document.title = title;
  if (favicon !== null) {
    //@ts-ignore
    favicon.href = link;
  } else {
    favicon = document.createElement("link");
    //@ts-ignore
    favicon.rel = "icon";
    //@ts-ignore
    favicon.href = link;
    document.head.appendChild(favicon);
  }
};
changeFavicon(postData?.ico, postData?.title);

const BASE_URL = `${postData?.postUrl}/manage-backend/`;

const TIME_OUT = 10000;

export { BASE_URL, TIME_OUT, postData };
